import { ReactNode } from "react";
import {
  AgricultureOutlined,
  ApartmentOutlined,
  BatteryChargingFullOutlined,
  BoltOutlined,
  CameraAltOutlined,
  DirectionsCarOutlined,
  DnsOutlined,
  EnergySavingsLeafOutlined,
  LaptopOutlined,
  LocalShippingOutlined,
  TwoWheelerOutlined,
  WbSunnyOutlined,
} from "@mui/icons-material";
import { ContainerIcon, StethoscopeIcon } from "@components/ui_v2/iconosLucide";

/**
 * MOCK de `SeleccionActivo` (Pymio, flujo activo): catálogo de activos del diseño (`PYM_ACTIVOS` de
 * `ui_v2/dev/pantallas/pymio.tsx` y `data/activos.ts`). Se reemplaza por el servicio cuando exista.
 */

export interface TipoActivoMock {
  id: string;
  label: string;
  sub: string;
  icon: ReactNode;
}

export interface FamiliaActivoMock {
  id: string;
  /** Código del leasing type (`leasing_type_config`) con el que se cruza la familia; el mismo del cotizador. */
  code: string;
  label: string;
  sub: string;
  icon: ReactNode;
  tipoLabel: string;
  tipos: TipoActivoMock[];
}

const icon = (Icon: typeof DirectionsCarOutlined) => <Icon fontSize="small" />;

export const FAMILIAS_ACTIVO_MOCK: FamiliaActivoMock[] = [
  {
    id: "vehicular",
    code: "LTVHA",
    label: "Vehicular",
    sub: "Autos, SUVs, vans y camiones",
    icon: <DirectionsCarOutlined />,
    tipoLabel: "Tipo de vehículo",
    tipos: [
      { id: "auto", label: "Autos comerciales", sub: "Sedanes, SUV y pickups", icon: icon(DirectionsCarOutlined) },
      { id: "moto", label: "Motocicletas", sub: "Trabajo, reparto y uso urbano", icon: icon(TwoWheelerOutlined) },
      { id: "van", label: "Vans", sub: "Carga ligera y reparto", icon: icon(LocalShippingOutlined) },
      {
        id: "tracto",
        label: "Tractocamión y remolques",
        sub: "Tráiler, quinta rueda, cajas secas, plataformas y tolvas",
        icon: icon(ContainerIcon),
      },
      {
        id: "camion",
        label: "Camión de carga",
        sub: "Torton, rabón, volteo y refrigerado",
        icon: icon(LocalShippingOutlined),
      },
    ],
  },
  {
    id: "maquinaria",
    code: "LTMQA",
    label: "Maquinaria y equipo",
    sub: "Amarilla, montacargas, producción, mobiliario",
    icon: <AgricultureOutlined />,
    tipoLabel: "Tipo de maquinaria o equipo",
    tipos: [
      {
        id: "excavacion",
        label: "Construcción y excavación",
        sub: "Excavadoras, retroexcavadoras, cargadores",
        icon: icon(AgricultureOutlined),
      },
      {
        id: "compactacion",
        label: "Compactación y pavimento",
        sub: "Rodillos, motoconformadoras, pavimentadoras",
        icon: icon(AgricultureOutlined),
      },
      {
        id: "elevacion",
        label: "Elevación y manejo",
        sub: "Montacargas, telehandlers, plataformas",
        icon: icon(LocalShippingOutlined),
      },
      {
        id: "agricola",
        label: "Agrícola",
        sub: "Tractores, cosechadoras e implementos",
        icon: icon(EnergySavingsLeafOutlined),
      },
      {
        id: "produccion",
        label: "Producción y empaque",
        sub: "Líneas, CNC, compresores, tableros",
        icon: icon(ApartmentOutlined),
      },
      {
        id: "cocina",
        label: "Cocina y refrigeración",
        sub: "Hornos, cámaras, exhibidores",
        icon: icon(ApartmentOutlined),
      },
      {
        id: "oficina",
        label: "Mobiliario y oficina",
        sub: "Mobiliario, aire acondicionado, impresión",
        icon: icon(ApartmentOutlined),
      },
    ],
  },
  {
    id: "energia",
    code: "LTSEA",
    label: "Solares y energía",
    sub: "Fotovoltaico, baterías y respaldo",
    icon: <EnergySavingsLeafOutlined />,
    tipoLabel: "Tipo de equipo",
    tipos: [
      {
        id: "paneles",
        label: "Paneles solares",
        sub: "Sistemas fotovoltaicos para techo o piso",
        icon: icon(WbSunnyOutlined),
      },
      {
        id: "baterias",
        label: "Baterías y almacenamiento",
        sub: "Bancos de baterías e inversores",
        icon: icon(BatteryChargingFullOutlined),
      },
      {
        id: "respaldo",
        label: "Plantas de respaldo",
        sub: "Generadores y plantas de emergencia",
        icon: icon(BoltOutlined),
      },
    ],
  },
  {
    id: "especializado",
    code: "LTTMA",
    label: "Tecnología y médico",
    sub: "Cómputo, redes e imagenología",
    icon: <StethoscopeIcon />,
    tipoLabel: "Tipo de equipo",
    tipos: [
      { id: "computo", label: "Cómputo y laptops", sub: "Equipos de trabajo y estaciones", icon: icon(LaptopOutlined) },
      {
        id: "infraestructura",
        label: "Servidores y redes",
        sub: "Servidores, storage y networking",
        icon: icon(DnsOutlined),
      },
      { id: "imagen", label: "Imagenología", sub: "Rayos X, ultrasonido, tomografía", icon: icon(CameraAltOutlined) },
      {
        id: "consultorio",
        label: "Consultorio y quirófano",
        sub: "Mesas, monitores, esterilización",
        icon: icon(StethoscopeIcon),
      },
    ],
  },
];
